import { render, staticRenderFns } from "./ProjectIdCard.vue?vue&type=template&id=079e1c16&scoped=true&"
import script from "./ProjectIdCard.vue?vue&type=script&lang=ts&"
export * from "./ProjectIdCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079e1c16",
  null
  
)

export default component.exports